import React, { createContext, useState, useMemo, useContext, useEffect, useCallback } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

const ThemeContext = createContext({
  toggleColorMode: () => {},
});

export function CustomThemeProvider({ children }) {
  const getInitialMode = () => {
    const savedMode = localStorage.getItem('themeMode');
    return savedMode || 'light'; // Simplificado
  };

  const [mode, setMode] = useState(getInitialMode());

  useEffect(() => {
    localStorage.setItem('themeMode', mode);
  }, [mode]);

  // Usando useCallback para a função, que é semanticamente mais correto.
  const toggleColorMode = useCallback(() => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  }, []);

  // O valor fornecido pelo nosso contexto
  const contextValue = useMemo(() => ({ toggleColorMode }), [toggleColorMode]);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          // Suas paletas de cores aqui...
        },
      }),
    [mode],
  );

  return (
    <ThemeContext.Provider value={contextValue}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}

export const useThemeToggle = () => useContext(ThemeContext);